var currentProductOnPage;

/**
 * Plugin to handle the Google Map
 */

(function ($) {

  'use strict';

  var pluginName = 'themeMap',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   */
  function Plugin(element) {
    this.mapContainer = $(element);
    this.googleMap = this.mapContainer.find('.featured-map__gmap').get(0);
    this.options = JSON.parse(this.mapContainer.attr('data-section-settings'));

    if (this.options['apiKey'] && this.options['mapAddress']) {
      var $script = $('script[src*="' + this.options['apiKey'] + '&"]'),
        self = this;

      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + this.options['apiKey']
        ).then(function() {
          self._initMap();
        });
      } else {
        this._initMap();
      }
    }
  }

  Plugin.prototype._initMap = function() {
    var geocoder = new google.maps.Geocoder(),
      self = this;

    geocoder.geocode({ address: this.options['mapAddress'] }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        if (Shopify.designMode) {

        }
      } else {
        var mapOptions = {
          zoom: self.options['zoom'],
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        };

        var map = new google.maps.Map(self.googleMap, mapOptions);
        var center = map.getCenter();

        map.setCenter(center);

        var icon = {
          path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
          fillColor: "#eccacf",
          fillOpacity: 1,
          anchor: new google.maps.Point(15,55),
          strokeWeight: 0,
          scale: window.matchMedia('screen and (max-width: 499px)').matches ? 0.6 : 0.8
        };

        new google.maps.Marker({
          map: map,
          position: map.getCenter(),
          icon: icon
        });

        google.maps.event.addDomListener(window, 'resize', function() {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        });
      }
    });
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle all the dynamic features of a product
 */

(function ($) {

  'use strict';

  var pluginName = 'product',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {object} options The plugin options
   */
  function Plugin(element, options) {
    this.element = $(element);
    this.enableHistoryState = options['enableHistoryState'];
    this.hasColorSwatch = options['hasColorSwatch'];
    this.product = options['product'];
    this.selectedVariantId = options['selectedVariantId'];
    this.masterSelectorId = options['masterSelectorId'];
    this.ajaxAddToCart = options['ajaxAddToCart'];
    this.showPaymentButton = options['showPaymentButton'];
    this.context = options['context'];
    this.inventories = options['inventories'] || {};

    this._init();
  }

  /**
   * Init the plugin
   */
  Plugin.prototype._init = function() {
    // Add a listener when clicking the add to cart button
    if (this.ajaxAddToCart) {
      this.element.find('[data-action="add-to-cart"]').on('click', $.proxy(this.addToCart, this));
      this.element.find('[data-action="close-form-status"]').on('click', function(e) {
        $(e.currentTarget).closest('.product__form-status').slideUp();
        e.preventDefault();
      });
    }

    // Init the option selectors
    if (this.product['variants'].length > 1) {
      var optionSelectors = new Shopify.OptionSelectors(this.masterSelectorId, {
        product: this.product,
        onVariantSelected: $.proxy(this.onVariantSelected, this),
        enableHistoryState: this.enableHistoryState
      });

      optionSelectors.selectVariant(this.selectedVariantId);

      var productForm = this.element.find('.product__form');


      // If there is only one option, Shopify OptionSelector does not add the label, so we do it
      if (this.product['options'].length === 1) {
        productForm.find('#' + this.masterSelectorId + '-option-0').before(
          '<label for="' + this.masterSelectorId + '-option-0">' + this.product['options'][0] + '</label>'
        );
      }

      // We add our own classes for easier styling

      
      var selectorWrappers = productForm.find('.selector-wrapper'),
        selectorLabels = selectorWrappers.find('label'),
        selectorSelects = selectorWrappers.find('select'),
        selectorOptions = selectorSelects.find('option');

      selectorWrappers.addClass('form__control');
      selectorWrappers.css('display','none');
      selectorLabels.addClass('form__label');
      selectorSelects.wrap('<div class="form__select"></div>')
        .before(` <svg class="icon icon-arrow-bottom" 
                      width="16px" 
                      height="9px" 
                      viewBox="0 0 10 4" 
                      version="1.1" 
                      xmlns="http://www.w3.org/2000/svg" 
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path fill="none" stroke="#000" stroke-linecap="round" d="M9 0L5 4 1 0"/>
                  </svg>`);
                  
    } else {
      this.onVariantSelected(this.product['variants'][0]);
      
    }

    // Let's integrate with color swatch
    if (this.hasColorSwatch) {

      this.element.find('.product__details .swatch__item').on('click', function () {
        var optionIndex = $(this).closest('.product__details .swatch').attr('data-option-index'),
          optionValue = $(this).find(':radio').val();

        $(this).siblings().removeClass('swatch__item--active').end().addClass('swatch__item--active');

        $(this).closest('.product__details .product__form').find('.single-option-selector')
          .eq(optionIndex).val(optionValue).trigger('change');
      });

      this.element.find('.targetProduct').on('click', function () {
        var optionIndex = $(this).closest('.complete-look-product .swatch').attr('data-option-index'),
          optionValue = $(this).find(':radio').val();

        $(this).siblings().removeClass('swatch__item--active').end().addClass('swatch__item--active');

        $(this).closest('.complete-look-product .product__form').find('.single-option-selector')
          .eq(optionIndex).val(optionValue).trigger('change');
      });
    }

    // Finally, the size chart link
    var sizeChart = $('.product__size-chart');
    currentProductOnPage = this.product;
    if (sizeChart.length > 0) {
      var sizeChartModal = $('.size-chart-modal');

      $('label[for="product-select-' + sizeChart.attr('data-product') + '-option-' + sizeChart.attr('data-option-index') + '"]')
        .append(sizeChart);

      sizeChart.on('click', function() {
        sizeChartModal.bPopup({
          positionStyle: 'fixed',
          closeClass: 'modal__close',
          opacity: 0.5,
          transition: 'slideDown',
          transitionClose: 'slideDown'
        });
      });
    }
  };

  $('.product__size-chart-customize').on('click', function() {
        $('.size-chart-modal-customize').bPopup({
          positionStyle: 'fixed',
          closeClass: 'modal__close',
          opacity: 0.5,
          transition: 'slideDown',
          transitionClose: 'slideDown'
        });
      });

  $('.product__size-chart-unisex').on('click', function() {
    $('.size-chart-modal-customize-unisex').bPopup({
      positionStyle: 'fixed',
      closeClass: 'modal__close',
      opacity: 0.5,
      transition: 'slideDown',
      transitionClose: 'slideDown'
    });
  });
  /**
   * Called when the variant changes
   */
  Plugin.prototype.onVariantSelected = function(variant) {
    var productMeta = this.element.find('.product__meta'),
      productPrices = productMeta.find('.product__prices'),
      addToCartButton = this.element.find('.product__add-to-cart'),
      paymentButton = this.element.find('.shopify-payment-button');

    // For the various meta, as they depend on the variant status, we always remove them to start with
    productMeta.find('.product__price, .product__sale-percent, .label:not(.label--custom)').remove();

    if (variant) {
      
      if (!variant['available']) {
        addToCartButton.removeClass('button--primary button--secondary').addClass('button--secondary').attr('disabled', 'disabled').text(window.languages.soldOutLabel);
        paymentButton.hide();
      } else {
        addToCartButton.removeClass('button--primary button--secondary').addClass(this.showPaymentButton ? 'button--secondary' : 'button--primary').removeAttr('disabled').text(window.languages.addToCartLabel);
        paymentButton.show();

        // Otherwise, the product could be on sale
        if (variant['compare_at_price'] > variant['price']) {
          productPrices.append('<span tabindex="0" class="product__price product__price--old" data-money-convertible>' + Shopify.formatMoney(variant['compare_at_price'], window.shop['moneyFormat']) + '</span>');
          productPrices.append('<span tabindex="0" class="product__price product__price--new" data-money-convertible>' + Shopify.formatMoney(variant['price'], window.shop['moneyFormat']) + '</span>');
          productPrices.append('<span tabindex="0" class="product__sale-percent">-' + Math.round(((variant['compare_at_price'] - variant['price']) * 100 / variant['compare_at_price'])) + '%</span>');
        } else {
          productPrices.append('<span tabindex="0" class="product__price" data-money-convertible>' + Shopify.formatMoney(variant['price'], window.shop['moneyFormat']) + '</span>');
        }
      }

      if (this.inventories[variant['id']]) {
        this.element.find('.product__inventory-count').text(this.inventories[variant['id']]['inventory_quantity']);
      }

      // Let's update the swatch
      if (this.hasColorSwatch) {
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var valueToCheck = variant.options[i];

          var radioButton = this.element.find('.swatch[data-option-index="' + i + '"] :radio').filter(function () {
            return $(this).val() === valueToCheck;
          });

          if (radioButton.size()) {
            radioButton.attr('checked', 'checked').closest('.swatch__item').addClass('swatch__item--active').siblings().removeClass('swatch__item--active');
          }
        }
      }

      if (this.context === 'home') {
        this._updateFeaturedImage(variant);
      }
    } else {
     
      // Variant simply do not exist, so we update the add to cart button
      addToCartButton.removeClass('button--primary button--secondary').addClass('button--secondary').attr('disabled', 'disabled').text(window.languages.unavailableLabel);
      paymentButton.hide();

      this.element.find('.product__inventory-count').text(0);
    }

    

    // We trigger an event so that other code can bind their own logic
    $(document).trigger('variant_changed', variant);
  };

  /**
   * Called when the product is added to the cart
   */
  Plugin.prototype.addToCart = function() {
    var productStatus = this.element.find('.product__form-status'),
      addToCartButton = this.element.find('.product__add-to-cart');

    addToCartButton.text(window.languages.addingToCartLabel).attr('disabled', 'disabled');

    var variantSignature = $('.single-option-selector').map((c, i)=>$(i).val()).get().join("/");
    var variantId = $(`.product__option-selector option[data-color-size="${variantSignature}"]`).val();
     if(variantId == undefined){
      variantId = $('.product__option-selector option:selected').val();
     }    
    var variantQuantity=$('.product__quantity').val()
    var payloadForAddjs = {"items": [
      {
        "quantity": variantQuantity,
        "id": variantId
      }
    ]}
    
    $.ajax({
      method: 'POST',
      url: '/cart/add.js',
      //data: this.element.find('.product__form').serialize(),
      data: payloadForAddjs,
      dataType: 'json',
      success: function() {
        productStatus.find('.product__form-message').removeClass('product__form-message--error').addClass('product__form-message--success').text(window.languages.productAddedStatus);
      },
      error: function(data) {
        productStatus.find('.product__form-message').addClass('product__form-message--error').removeClass('product__form-message--success').text(data.responseJSON['description']);
      },
      complete: function() {
        addToCartButton.text(window.languages.addToCartLabel).removeAttr('disabled');
        productStatus.slideDown();         
        // Finally, we do another call to get the latest status of the cart
        $.ajax({
          url: '/cart.js',
          dataType: 'json'
        }).always(function(cart) {
          $(document).trigger('cart.updated', cart);
          autoaddtocart(cart,1);
        });                
      }
    });    
    return false;
  };

  /**
   * This is ONLY used for the "featured product" section on home page
   * @private
   */
  Plugin.prototype._updateFeaturedImage = function(variant) {
    if (!variant['featured_image']) {
      return;
    }

    var productImage = this.element.find('.featured-product__image'),
      aspectRatio = variant['featured_image']['width'] / variant['featured_image']['height'];

    productImage.attr('data-sizes', 'auto')
      .attr('data-widths', '[' + this._getSupportedSizes(variant['featured_image'], [200,300,400,600,800,900,1000]).join(',') + ']')
      .attr('data-src', this._getSizedImageUrl(variant['featured_image']['src'], '1x1').replace('_1x1.', '_{width}x.'))
      .addClass('lazyload');

    productImage.parent('.aspect-ratio').css('padding-bottom', (100.0 / aspectRatio) + '%');
  };

  Plugin.prototype._getSizedImageUrl = function(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return src.replace(/http(s)?:/, '');
    }

    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];

      return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
    } else {
      return null;
    }
  };

  Plugin.prototype._getSupportedSizes = function(image, desiredSizes) {
    var supportedSizes = [],
      imageWidth = image['width'];

    desiredSizes.forEach(function(width) {
      if (imageWidth >= width) {
        supportedSizes.push(width);
      }
    });

    return supportedSizes;
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

var router = new RouterRouter();

router.route('account/addresses', function() {
  /**
   * -------------------------
   * MODALS
   * -------------------------
   */

  $('[data-action="open-new-address-modal"]').on('click', function(e) {
    $('.addresses__new').bPopup({
      positionStyle: 'fixed',
      closeClass: 'addresses__close',
      transition: 'slideDown',
      transitionClose: 'slideUp'
    });

    e.preventDefault();
  });

  $('[data-action="open-edit-address-modal"]').on('click', function(e) {
    $('.addresses__edit[data-address="' + $(this).attr('data-address') + '"]').bPopup({
      positionStyle: 'fixed',
      closeClass: 'addresses__close',
      transition: 'slideDown',
      transitionClose: 'slideUp'
    });

    e.preventDefault();
  });
});
router.route('*all', function() {
  var pageOverlay=  $('.page__overlay');

  /**
   * -------------------------
   * CART COUNT
   * -------------------------
   */

  var cartItemCount = $('.cart-item-count');

  $(document).on('cart.updated', function(event, data) {    
    jQuery.getJSON('/cart.js', function(cart) {
        cartItemCount.css('visibility', parseInt(cart.item_count) === 0 ? 'hidden' : 'visible'); 
        cartItemCount.html(cart.item_count); 
        cartItemCount.attr('aria-label', cart.item_count);                   
    });
    
    setTimeout(function(){
      jQuery.getJSON('/cart.js', function(cart) {
        autoaddtocart(cart,execute);                   
    });
    },500);    
    
  });

  

  /**
   * -------------------------
   * DESKTOP NAV
   * -------------------------
   */

  // In order to avoid off-screen, we have to do some additional manipulation
  (function() {
    $('body').on('mouseenter', '.menu__links--level-0 > .menu__item--has-submenu', function() {
      var windowWidth = window.innerWidth,
        item = $(this),
        nestedMenu = item.find('.menu__links--level-1');

      if (nestedMenu.hasClass('mega-nav')) {
        var toggleLink = item.children('.menu__link'),
          rightEdge = toggleLink[0].getBoundingClientRect().right;

        if ((rightEdge + nestedMenu.width()) > windowWidth) {
          nestedMenu.addClass('mega-nav--left');
        } else {
          nestedMenu.removeClass('mega-nav--left');
        }
      } else {
        var nestedMenus = nestedMenu.find('.menu__links--level-2'),
          rightEdge = this.getBoundingClientRect().right,
          shouldOpenLeft = false;

        nestedMenus.each(function(index, item) {
          if ((rightEdge + item.offsetWidth) > windowWidth) {
            shouldOpenLeft = true;
            return false; // this allows to break from the each
          }
        });

        if (shouldOpenLeft) {
          nestedMenus.addClass('menu__links--left');
        } else {
          nestedMenus.removeClass('menu__links--left');
        }
      }
    })
  }());

  /**
   * -------------------------
   * MOBILE NAV
   * -------------------------
   */

  $('.header__mobile-icon').on('click', function(event) {
    var element = $(this);

    // If no content to display, we want the user to be redirected to the page
    if (element.attr('data-has-menu') === 'false') {
      return;
    }

    var tab = element.closest('.header__mobile-tab');

    // We close the other tab (if any open) and add the class to itself
    tab.siblings().removeClass('header__mobile-tab--open').find('.header__mobile-content').slideUp(0);

    tab.toggleClass('header__mobile-tab--open');
    tab.find('.header__mobile-content').slideToggle(150);

    if (tab.hasClass('header__mobile-tab--open')) {
      pageOverlay.addClass('page__overlay--open');
      tab.find('.mobile-search__input').focus();
    } else {
      pageOverlay.removeClass('page__overlay--open');
      tab.find('.mobile-search__input').blur();
    }

    event.preventDefault();
  });

  $('.menu__icon-container').on('click', function(event) {
    var menuIconContainer = $(this),
      menu = menuIconContainer.closest('.menu__item');

    menuIconContainer.attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'});
    menu.toggleClass('menu__item--open');

    if (menu.hasClass('menu__item--open')) {
      menu.children('.menu__links').slideDown();
    } else {
      menu.find('.menu__links').slideUp();
      menu.find('.menu__item--open').removeClass('menu__item--open');
    }

    event.preventDefault();
  });

  bouncefix.add('header__mobile-content');

  /**
   * -------------------------
   * MEGA NAV
   * -------------------------
   */

  var megaNavDropdownImageContainer = $('.mega-nav__image');

  $('.dropdown-column__list-link[data-image]').on('mouseenter', function() {
    megaNavDropdownImageContainer.attr('src', $(this).attr('data-image'));
  });

  /**
   * -------------------------
   * QUICK SHOP
   * -------------------------
   */

  $('body').on('click', '[data-action="open-quick-shop"]:not(".js-quick-add-size-button")', function(e) {
    // We get the ID of the product
    if (e.target.classList.contains('js-quick-add-size-button')){
       return false;
    }
    var productId = $(this).attr('data-product-id');

    // We get the corresponding quick shop. Because multiple may exist in the page, we only display the first one
    $('.quick-shop[data-product-id="' + productId + '"]').first().bPopup({
      positionStyle: 'fixed',
      onOpen: function() {
        var quickShop = $(this),
            isInitialized = quickShop.attr('data-initialized');

        // First, let's initialize the various resources (images, and slideshow)
        if (isInitialized === 'false') {
          var slider = quickShop.find('.quick-shop__slideshow').slick({
            fade: true,
            adaptiveHeight: true,
            lazyLoad: 'progressive',
            arrows: false,
            dots: false
          }).slick('getSlick');

          // Finally, let's initialize the product selectors
          window['initializeQuickShop' + productId]();

          $(document).on('variant_changed.quick_shop', function(event, variant) {
            if (variant['featured_image']) {
              var position = quickShop.find('.quick-shop__slideshow-slide[data-image-id="' + variant['featured_image']['id'] + '"]').index();
              slider.goTo(position);
            }
          });

          quickShop.attr('data-initialized', 'true');
        }
      }
    });

    return false;
  });

  /**
   * -------------------------
   * AUTOMATIC CURRENCY CONVERSION
   * -------------------------
   */

  

  /**
   * -------------------------
   * MARKETING POPUP
   * -------------------------
   */

  

  /**
   * ----------------------------
   * FEATURED MAP
   * ----------------------------
   */

  (function() {
    $('.featured-map').themeMap();

    $(document).on('shopify:section:load', '.shopify-section__featured-map', function(event) {
      $(event.target).find('.featured-map').themeMap();
    });
  }());

  /**
   * -------------------------
   * SEARCH
   * -------------------------
   */

  $('body').on('click', '[data-action="open-mega-search"]', function() {
    $('.mega-search').bPopup({
      positionStyle: 'fixed',
      closeClass: 'icon-cross',
      opacity: 0.8,
      position: ['auto', 200],
      onOpen: function() {
        setTimeout(function() {$('.mega-search__input').focus()}, 0);
      }
    });

    return false;
  });
 	$('body').on('click', '[data-action="open-mega-search"]', function() {
    $('.mega-search').bPopup({
      positionStyle: 'fixed',
      closeClass: 'icon-cross',
      opacity: 0.8,
      position: ['auto', 200],
      onOpen: function() {
        setTimeout(function() {$('.mega-search__input').focus()}, 0);
      }
    });

    return false;
  });

        $(".product__add-to-cart ").click(function() {

            $(".b-modal").css('display', 'none');
         $(".quick-shop").css('display', 'none');
      });


  // Let's trigger the auto-complete
  var autocompleteXhr,
    megaSearchSuggestions = $('.mega-search__suggestions'),
    megaSearchSpinner = $('.mega-search__spinner');

  $('.mega-search__input').autoComplete({
    minChars: 1,
    delay: 50,

    // Function that is called to get suggestions from Shopify
    source: function(term, done) {
      try {
        autocompleteXhr.abort();
      } catch(e) {}

      megaSearchSpinner.show();

      var searchData = {
        q: term + '*', // We automatically add wildcard for partial matching
        view: 'json',
        type: "product"
      };

      autocompleteXhr = $.ajax({
        url: '/search',
        dataType: 'json',
        data: searchData
      }).then(function(data) {
        megaSearchSpinner.hide();
        done(data);

        
      });
    },

    renderItem: function(data, search) {
      var objectType = data['object_type'],
        node = null;

      switch (objectType) {
        case 'product':
          node = ''
            + '<div>'
            +   '<img class="mega-search__image" src="' + data['image'] + '">'
            +   '<div class="mega-search__info">'
            +       '<span class="mega-search__item-title">' + data['title'] + '</span>'
            +       '<span class="mega-search__item-subtitle"><span class="mega-search__item-price" data-money-convertible>' + Shopify.formatMoney(data['price_min'], window.shop.moneyFormat) + '</span></span>'
            +   '</div>'
            + '</div>';

          break;

        case 'article':
          node = ''
            + '<div>'
            +   '<img class="mega-search__image" src="' + data['image'] + '">'
            +   '<div class="mega-search__info">'
            +       '<span class="mega-search__item-title">' + data['title'] + '</span>'
            +       '<span class="mega-search__item-subtitle">' + data['blog'] + '</span>'
            +   '</div>'
            + '</div>';

          break;

        case 'page':
          node = ''
            + '<div>'
            +   '<img class="mega-search__image" src="' + data['image'] + '">'
            +   '<div class="mega-search__info">'
            +       '<span class="mega-search__item-title">' + data['title'] + '</span>'
            +       '<span class="mega-search__item-subtitle">' + window.languages.autocompletePageType + '</span>'
            +   '</div>'
            + '</div>';
          break;

        case 'all_results':
          node = ''
            + '<div>'
              + '<span class="mega-search__all-results">' + window.languages.autocompleteSeeAll + ' (' + data['results_count'] + ')' + '</span>'
            + '</div>';

          break;
      }

      return '<li class="mega-search__suggestion autocomplete-suggestion" data-url="' + data['url'] + '">' + node + '</li>';
    },

    // Function called when an element is selected
    onSelect: function(e, term, item) {
      location.href = item.attr('data-url');
      e.preventDefault();
    }
  });

  /**
   * -------------------------
   * ALTERNATE IMAGES
   * -------------------------
   */

  // Focal offers a feature where people can hover a collection item and display an alternate image. This can happen
  // in various pages (home, collection, search, product...). The trick is that touch devices do not have hover, so
  // it's useless to load alternate images for those devices. Instead, we add alternate images tag for non-touch
  // devices, which will start loading the alternate images
  if (!Modernizr.touchevents || Modernizr.mq('(min-width: 1025px)')) {
    var loadAlternateProductImages = function() {
      $('.product-item:not(.related-products__item) .product-item__image[data-alternate-src]').each(function(index, item) {
        var image = $(item),
          alternateImage = new Image();

        alternateImage.src = image.attr('data-alternate-src');
        alternateImage.className = 'product-item__image product-item__image--alternate';        
        alternateImage.alt = image.attr("alt");
        alternateImage.tabIndex=10;
        alternateImage.onload = function() {
          image.after(alternateImage);
          image.closest('.product-item__figure').addClass('product-item__figure--alternate-image-loaded');
        };
      });
    };

    loadAlternateProductImages();

    $(document).on('shopify:section:load', function() {
      loadAlternateProductImages();
    });
  }

  /**
   * -------------------------
   * OTHER
   * -------------------------
   */

  $(document).on('shopify:section:load', function() {
    window.doPostSectionsInit();
  });
});
router.route('cart', function() {
  var cartTotal = $('.cart__total-amount');

  // Add the note using CartJS
  $('.cart__note').on('change', function() {
    $.post('/cart/update.js', {note: $(this).val()});
  });



  $('.cart-item__quantity').on('change', function() {
    // We add one because Shopify uses 1-index numbering
    var element = $(this),
      lineItem = element.closest('.cart-item'),
      lineIndex = parseInt(lineItem.attr('data-index'));

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        line: lineIndex,
        quantity: element.val()
      },
      success: function(data) {
        var lineItemLinePrice = data['items'][lineIndex - 1]['line_price'],
          moneyFormat = window.shop.moneyFormat;

        lineItem.find('.cart-item__line-price').html(Shopify.formatMoney(lineItemLinePrice, moneyFormat));
        cartTotal.html(Shopify.formatMoney(data['total_price'], moneyFormat));

                
        // Trigger event so that other part of the code can update other code like the top cart
        $(document).trigger('cart.updated', data);
      }
    });
  });
  /**
   * -------------------------
   * TERMS AND CONDITIONS
   * -------------------------
   */

  $('body').on('click', 'input[name="checkout"]', function() {
    var termsCheckbox = $('#terms');

    if (termsCheckbox.length > 0 && !termsCheckbox.is(':checked')) {
      alert(window.languages.cartTerms);
      return false;
    }
  });

  /**
   * -------------------------
   * SHIPPING ESTIMATOR
   * -------------------------
   */

  (function() {
    var initShippingEstimator = function() {
      new Shopify.CountryProvinceSelector('address_country', 'address_province', {hideElement: 'address_province_container'});

      var shippingEstimator = $('.shipping-estimator'),
        shippingEstimatorSubmit = shippingEstimator.find('.shipping-estimator__submit'),
        shippingEstimatorResults = shippingEstimator.find('.shipping-estimator__results'),
        shippingEstimatorList = shippingEstimatorResults.find('.alert__errors'),
        cartEstimatedShipping = $('.cart__taxes');

      $('.shipping-estimator__submit').on('click', function() {
        shippingEstimatorSubmit.text(window.languages.shippingEstimatorSubmitting);

        $.ajax({
          method: 'GET',
          url: '/cart/shipping_rates.json',
          data: {
            shipping_address: {
              country: shippingEstimator.find('#address_country').val(),
              province: shippingEstimator.find('#address_province').val(),
              zip: shippingEstimator.find('#address_zip').val()
            }
          },
          success: function(results) {
            shippingEstimatorList.empty();
            shippingEstimatorResults.find('.alert').removeClass('alert--error').addClass('alert--success');

            if (results['shipping_rates'].length === 0) {
              shippingEstimatorResults.find('.alert__title').text(window.languages.shippingEstimatorNoRates);
            } else {
              shippingEstimatorResults.find('.alert__title').text(window.languages.shippingEstimatorRates);
            }

            results['shipping_rates'].forEach(function(item) {
              var amount = Shopify.formatMoney(item['price'] * 100, window.shop.moneyFormat);
              shippingEstimatorList.append('<li>' + item['name'] + ': <span data-money-convertible>' + amount + '</span></li>');
            });

            if (results['shipping_rates'].length > 0) {
              var firstPrice = Shopify.formatMoney(results['shipping_rates'][0]['price'] * 100, window.shop.moneyFormat);
              cartEstimatedShipping.text(window.languages.cartEstimatedShipping + ' ' + firstPrice);
              cartEstimatedShipping.show();
            }
          },
          error: function(results) {
            shippingEstimatorList.empty();
            shippingEstimatorResults.find('.alert').removeClass('alert--success').addClass('alert--error');
            shippingEstimatorResults.find('.alert__title').text(window.languages.shippingEstimatorError);

            var response = results.responseJSON,
              errors = [];

            for (var key in response) {
              if (response.hasOwnProperty(key)) {
                errors.push({key: key, value: response[key][0]});
              }
            }

            errors.forEach(function(item) {
              shippingEstimatorList.append('<li>' + item['key'] + ': ' + item['value'] + '</li>');
            });
          },
          complete: function(results) {
            shippingEstimatorSubmit.text(window.languages.shippingEstimatorSubmit);
            shippingEstimatorResults.show();
          }
        });

        return false;
      });
    };

   // initShippingEstimator();

    $(document).on('shopify:section:load', '#shopify-section-cart', function() {
     // initShippingEstimator();
    });
  }());
});
router.route('collections/*type', function() {
  /**
   * -------------------------
   * SORT BY AND FILTERS
   * -------------------------
   */

  Shopify.queryParams = {};

  $('.header__push-filter--sort select').val(window.shop.collectionSortBy).on('change', function () {
    Shopify.queryParams.sort_by = $(this).val();
    location.search = $.param(Shopify.queryParams);
  });

  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');

      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  $('.header__push-filter--tags select').on('change', function (event) {
    window.location.href = $(event.currentTarget).find(':selected').val();
  });

  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  var initInfiniteScrollHelper = function(element) {
    element.infiniteScrollHelper({
      loadingClassTarget: '.collection__loader',
      loadingClass: 'collection__loader--loading',
      startingPageCount: window.shop.currentPage,
      hasMore: true,

      loadMore: function(page, done) {
        var loadingTarget = $(this.loadingClassTarget);

        if (!this.hasMore || loadingTarget.length == 0) {
          done();
          return;
        }

        var targetUrl = $.query.load(loadingTarget.attr('data-next-page'));

        // We need to modify the "page" attribute of the fetched URL
        targetUrl = targetUrl.set('page', page);

        $.ajax({
          url: location.protocol + '//' + location.host + location.pathname,
          data: targetUrl.toString().slice(1) // Allow to remove the initial "?" character
        }).then(function(content) {
          done();

          var productItems = $(content).children();

          // Check if there is still content to load
          if (productItems.length === 0) {
            $('.collection__list--infinite-scroll').infiniteScrollHelper('destroy');
            loadingTarget.remove();
          } else {
            if (!Modernizr.touchevents || Modernizr.mq('(min-width: 1025px)')) {
              productItems.find('.product-item__image[data-alternate-src]').each(function(index, item) {
                var image = $(item),
                  alternateImage = new Image();

                alternateImage.src = image.attr('data-alternate-src');
                alternateImage.className = 'product-item__image product-item__image--alternate';
                alternateImage.alt="Product Image";
                alternateImage.onload = function() {
                  image.after(alternateImage);
                  image.closest('.product-item__figure').addClass('product-item__figure--alternate-image-loaded');
                };
              });
            }

            // We can append the content to the .collection__list container
            $('.collection__list').append(productItems);
          }
        });
      }
    });
  };

  initInfiniteScrollHelper($('.collection__list--infinite-scroll'));

  $(document).on('shopify:section:unload', function(event) {
    $(event.target).find('.collection__list--infinite-scroll').infiniteScrollHelper('destroy');
  });

  $(document).on('shopify:section:load', function(event) {
    initInfiniteScrollHelper($(event.target).find('.collection__list--infinite-scroll'));
  });
});
router.route('', function() {
  var isMobile = Modernizr.mq('(max-width: 48em)');

  /**
   * SLIDESHOW
   */

  var initSlideshow = function(slideshow) {
    slideshow.find('.slideshow__slides').slick({
      autoplay: (slideshow.attr('data-autoplay') === 'true'),
      autoplaySpeed: parseInt(slideshow.attr('data-cycle-speed')),
      adaptiveHeight: true,
      useTransform: true,
      dots: true,
      appendDots:'.slideshow .dots',
      fade: (slideshow.attr('data-animation-type') === 'fade'),
      appendArrows: slideshow,
      prevArrow: slideshow.find('.slideshow__prev'),
      nextArrow: slideshow.find('.slideshow__next'),
      zIndex: 1
    });

    slideshow.find('.slideshow__prev, .slideshow__next').on('click', function(e) {
      e.preventDefault();
    });
  };

  var slideshows = $('.slideshow');

  slideshows.each(function(idx, item) {
    initSlideshow($(item));
  });

  $(document).on('shopify:section:unload', '.shopify-section__slideshow', function(event) {
    $(event.target).find('.slideshow__slides').slick('unslick');
  });

  $(document).on('shopify:section:load', '.shopify-section__slideshow', function(event) {
    initSlideshow($(event.target).find('.slideshow'));
  });

  $(document).on('shopify:block:select', '.shopify-section__slideshow', function(event) {
    var currentSlide = $(event.target),
      slideshow = currentSlide.closest('.slideshow__slides');

    slideshow.slick('slickGoTo', currentSlide.attr('data-slide-index'));
    slideshow.slick('slickPause');
  });

  $(document).on('shopify:block:deselect', '.shopify-section__slideshow', function(event) {
    $(event.target).closest('.slideshow__slides').slick('slickPlay');
  });

  /**
   * INSTAGRAM
   */

  var formatInstagramDate = function(image) {
    var date = new Date(image.created_time * 1000),
      m = date.getMonth(),
      d = date.getDate(),
      y = date.getFullYear();

    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    image.created_time = monthNames[m] + ' ' + d + ', ' + y;

    return true;
  };

  var initInstagramWidget = function(instagramWidget) {
    var template = '<div class="grid__cell 1/2 1/3--handheld-and-up 1/' + instagramWidget.attr('data-images-per-row') + '--lap-and-up">' +
      '<div class="instagram__image-wrapper lazyload image--fade-in" data-bg="{{image}}">' +
        '<a href="{{link}}" target="_blank">' +
          '<div class="instagram__overlay">' +
            '<p class="instagram__caption">{{caption}}</p>' +
            '<time class="instagram__date">{{model.created_time}}</time>' +
          '</div>' +
        '</a>' +
      '</div>' +
    '</div>'; 

    var feed = new Instafeed({
      get: 'user',
      userId: 'self',
      accessToken: instagramWidget.attr('data-access-token'),
      sortBy: 'most-recent',
      limit: instagramWidget.attr('data-limit-images'),
      resolution: 'standard_resolution',
      template: template,
      filter: $.proxy(formatInstagramDate)
    });

    feed.run();
  };

  var resolution = isMobile ? 'low_resolution' : 'standard_resolution',
    instagramWidget = $('.index-module__instagram[data-access-token]');

  instagramWidget.each(function(idx, item) {
    initInstagramWidget($(item));
  });

  $(document).on('shopify:section:load', '.shopify-section__instagram', function(event) {
    // Instagram
    var instagramWidget = $(event.target).find('.index-module__instagram[data-access-token]');

    if (instagramWidget.length > 0) {
      initInstagramWidget(instagramWidget);
    }
  });
});
/**
 * ----------------------------------------------------------------------------------------------------
 * LOGIN
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/login', function() {
  /**
   * -------------------------
   * SWITCH TO RECOVER FORM
   * -------------------------
   */

  var switchToRecoverForm = function() {
    $('.account__login, .account__recover').toggle();
    $('.header__push-title').text(window.languages.recoverPassword);
  };

  $('[data-action="display-recover-form"]').on('click', function() {
    switchToRecoverForm();
    return false;
  });

  // We also switch if we directly have the hash "recover"
  if (window.location.hash === '#recover' || window.recoverPassword === true) {
    switchToRecoverForm();
  }
});
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productRoute = function() {
  /**
   * -------------------------
   * SLIDESHOW SLIDER
   * -------------------------
   */

  // For performance reason, we only create the zoom when we reach the slide. Also, if on a small mobile,
  // we remove this feature because it's hard to use
  var initProductSlideshow = function(productSlideshow) {
    var productSlideshowImages = productSlideshow.find('.product__slideshow-slide'),
        isZoomEnabled = productSlideshow.attr('data-zoom-enabled'),
        zoomMagnification = productSlideshow.attr('data-zoom-magnification');

    productSlideshow.on('init afterChange', function(event, slick) {
      try{
        var currentSlide = $(slick.$slides[slick.currentSlide]);
           console.log(currentSlide);
          if (isZoomEnabled === 'true' && !currentSlide.attr('data-slide-initialized') && !Modernizr.touchevents) {
            $(currentSlide).zoom({
              url: currentSlide.attr('data-image-large-url'),
              touch: false,
              magnify: zoomMagnification,
              onZoomIn: function() {
                $(this).prev().addClass('product__slideshow-image--zoomed');
              },
              onZoomOut: function() {
                $(this).prev().removeClass('product__slideshow-image--zoomed');
              }
            });
          }

      }
      catch(e)
      {
        console.log(e);

      }
      
    });

    productSlideshow.slick({
      useTransform: true,
      adaptiveHeight: true,
      initialSlide: parseInt(productSlideshow.attr('data-initial-slide')),
      dots: true,
      lazyLoad: false
    });


    // Make thumbnails focusable for keyboard navigation
    $('.product__slideshow-nav-image').attr('tabindex', '0').attr('role', 'button');

    $('.product__slideshow-nav-image').on('click', function(e) {
      productSlideshow.slick('slickGoTo', parseInt($(this).attr('data-slide-index')));
      e.preventDefault();
      console.log('thumbnail clicked');
      console.log($(this));
    });

    // Handle Enter key on thumbnail images to change main image
    $('.product__slideshow-nav-image').on('keydown', function(e) {
      if (e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32) {
        var slideIndex = parseInt($(this).attr('data-slide-index'));
        productSlideshow.slick('slickGoTo', slideIndex);
        e.preventDefault();
        
        // Force re-render by removing and re-adding styles
        setTimeout(function() {
          var $slickTrack = productSlideshow.find('.slick-track');
          var currentStyle = $slickTrack.attr('style');
          
          // Remove style attribute
          $slickTrack.removeAttr('style');
          
          // Force reflow
          $slickTrack[0].offsetHeight;
          
          // Re-add style attribute
          $slickTrack.attr('style', currentStyle);
          
          // Also call Slick's setPosition for good measure
          productSlideshow.slick('setPosition');
        }, 50);
      }
    });

    // We attach an event whenever the variant changed so we have the opportunity to modify the featured image
    $(document).on('variant_changed.product_slideshow', function(event, variant) {
      if (variant && variant['featured_image']) {
        var itemToFind = productSlideshowImages.filter('[data-image-id="' + variant['featured_image']['id'] + '"]'),
          index = productSlideshowImages.index(itemToFind);

          if (index >= 0) {
              productSlideshow.slick('slickGoTo', index);
          }
      }
    });
  };

  initProductSlideshow($('.product__slideshow--main'));

  $(document).on('shopify:section:unload', function(event) {
    var target = $(event.target);

    target.find('.product__slideshow--main').slick('unslick');
    target.find('.product__slideshow-nav-image').off('click keydown');
    $(document).off('.product_slideshow');
  });

  $(document).on('shopify:section:load', function(event) {
    initProductSlideshow($(event.target).find('.product__slideshow--main'));
  });

  /**
   * -------------------------
   * TABS
   * -------------------------
   */

  var initProductTabs = function() {
    $('.product__tab-title').on('click', function() {
      var element = $(this),
        tabsContent = element.closest('.product__tabs').find('.product__tabs-content .product__tab-content');

      // If it's already active, do nothing
      if (element.hasClass('product__tab-title--active')) {
        return;
      }

      element.siblings().removeClass('product__tab-title--active').end().addClass('product__tab-title--active');

      tabsContent.filter('.product__tab-content--active').fadeOut(125, function() {
        tabsContent.removeClass('product__tab-content--active').eq(element.attr('data-tab-index')).addClass('product__tab-content--active').fadeIn(125);
      });
    });

    $('.product__tab-selector select').on('change', function() {
      var element = $(this),
        tabsContent = element.closest('.product__tabs').find('.product__tabs-content .product__tab-content');

      tabsContent.filter('.product__tab-content--active').fadeOut(125, function() {
        tabsContent.removeClass('product__tab-content--active').eq(element.val()).addClass('product__tab-content--active').fadeIn(125);
      });
    });
  };

  initProductTabs();

  $(document).on('shopify:section:load', function(event) {
    initProductTabs();
  });

  /**
   * -------------------------
   * RELATED PRODUCTS
   * -------------------------
   */

  $('.related-products').find('.product-item__image[data-alternate-src]').each(function(index, item) {
    var image = $(item),
      alternateImage = new Image();

    alternateImage.src = image.attr('data-alternate-src');
    alternateImage.className = 'product-item__image product-item__image--alternate';
    alternateImage.alt="Product Image";
    alternateImage.onload = function() {
      image.after(alternateImage);
      image.closest('.product-item__figure').addClass('product-item__figure--alternate-image-loaded');
    };
  });
};

router.route('products/*type', productRoute);
router.route('collections/*collection/products/*type', productRoute);
router.route('search', function() {
  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  
});

$('.product__add-to-cart').on('click', function (e) {
 //e.preventDefault();
 $('.product_cart-custom').attr('aria-hidden','false').addClass('product_cart-custom--open');
 $('.product_cart-custom_overlay').attr('aria-hidden','false').addClass('product_cart-custom_overlay--open');
//  $('.product_cart-custom-your-cart').attr('aria-label','Your Shopping Cart open on a popup' );
 $('.product_cart-custom-your-cart').focus();
 
});

$('.product__add-to-cart').on('keypress', function (e) {
  //e.preventDefault();
  $('.product_cart-custom').attr('aria-hidden','false').addClass('product_cart-custom--open');
  $('.product_cart-custom_overlay').attr('aria-hidden','false').addClass('product_cart-custom_overlay--open');
  //  $('.product_cart-custom-your-cart').attr('aria-label','Your Shopping Cart open on a popup' );
  $('.product_cart-custom-your-cart').focus();
  
 });

$('.product_cart-close').on('click', function (e) {
 e.preventDefault();
 $('.product_cart-custom').attr('aria-hidden','true').removeClass('product_cart-custom--open');
 $('.product_cart-custom_overlay').attr('aria-hidden','true').removeClass('product_cart-custom_overlay--open');
 // Return focus to the header cart icon
 $('.header__cart-link').focus();
});

$('.product_cart-custom_overlay').on('click', function (e) {
  e.preventDefault();
 $('.btn-product_cart-close').click();
});

function reloadCart(timeout){
	var selector = 'form.cart__form .product_cart-scroll-block';
    $(selector).html(generateSideCartBlock());
}


function addCartQtytoPressKey(count,product_title,Size){
  $('.product__add-to-cart').attr('aria-label', 'Cart Quantity is '+ count );
  // Size XS "product Name" quantity 1 added to the cart
  $('.product_cart-custom-your-cart').attr('aria-label', product_title +', Selected Size ïs'+Size+', '+'Quantity is 1'+ ', added to the cart,'+ 'Your Shopping Cart open on a popup' );
  // console.log(product_title +', Selected Size ïs'+Size+', '+'Quantity is 1'+ ', added to the cart.');

}

function addProductDetailstoCartWhenPressKey(count,product_title,Size){
  var qty = $('.product__quantity').val();
  var selected_size = $("#sizeDropbtn").text();
  $('.product__add-to-cart').attr('aria-label', 'Cart Quantity is '+ count );
  // Size XS "product Name" quantity 1 added to the cart
  $('.product_cart-custom-your-cart').attr('aria-label', product_title +', '+ selected_size+', '+'Quantity is'+qty+ ', added to the cart,'+ 'Your Shopping Cart open on a popup.' );
  // console.log(product_title +', '+ selected_size+', '+'Quantity is'+qty+ ', added to the cart');

}

//Fixes -  While selecting or editing the quantity if user clicks on "Enter key" it is getting added to cart.
document.addEventListener('keydown', function (e) {
  const el = document.activeElement;

  if (e.key !== 'Enter') return;

  // ENTER on +
  if (el.classList.contains('quantity-arrow-plus')) {
    e.preventDefault();

    const input = el
      .closest('.quantity__wrapper')
      .querySelector('.product__quantity');

    input.stepUp();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ENTER on −
  if (el.classList.contains('quantity-arrow-minus')) {
    e.preventDefault();

    const input = el
      .closest('.quantity__wrapper')
      .querySelector('.product__quantity');

    input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ENTER inside quantity input → do NOT submit
  if (el.classList.contains('product__quantity')) {
    e.preventDefault();
  }
});


function cartQtyForCartIcon(){
  var result = {};
  $.ajax({
      url: '/cart.js',
      dataType: 'json',
      async: false
  }).always(function(response) {
      result = response;
  });
  $('.product__add-to-cart').attr('aria-label', 'Cart Quantity is '+ result.item_count );
  console.log(result.item_count);
  // return result;
}


//this varieble using for focus again used varient on collection page from cart
var varientIdForCart = '';
function quickAddToCart(variantID){
  varientIdForCart =  variantID;
	jQuery.post('/cart/add.js', {
  		quantity: 1,
  		id: variantID,
    }).always(function(){
	  $('.product_cart-custom').attr('aria-hidden','false').addClass('product_cart-custom--open');
	  $('.product_cart-custom_overlay').attr('aria-hidden','false').addClass('product_cart-custom_overlay--open');
    $('.product_cart-custom-your-cart').focus();
    reloadCart();
    $(document).trigger('cart.updated');    
    });   
    execute = 1 ;   
    // $('.btn-product_cart-close').focus();
    
}



// for cart close button keydown event 
$('.btn-product_cart-close').on('keydown', function (e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    $('.product_cart-custom').attr('aria-hidden','true').removeClass('product_cart-custom--open');
    $('.product_cart-custom_overlay').attr('aria-hidden','true').removeClass('product_cart-custom_overlay--open');
    // Return focus to the header cart icon
    $('.cart-focus').focus();
  }
});


// $('#continueSHoppingID').focus( function () {
// }).blur(function(){
//   $('.btn-product_cart-close').focus();
// });

// $(document).on('ready', function(){
//   $('.btn-product_cart-close').keypress(function(){
//     $('.product_cart-custom-your-cart').attr('aria-label','Your Shopping Cart open on a popup' );
//     $('#'+varientIdForCart).focus();  
//   });
// });



function updateProductQuanitityInCart(element,quantity,forceReload){
  lineItem = element.closest('.cart-item__actions'),
	lineIndex = element.data('line-item-index');
	quantity = quantity != undefined ? quantity : element.val()
	if (quantity == 0){
		forceReload = true;
	}
 
	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		dataType: 'json',
		data: {line: lineIndex, quantity: quantity},
		success: function(data) {
			reloadCart();
			var lineItemLinePrice = data['items'][lineIndex - 1] ? data['items'][lineIndex - 1]['line_price'] : 0,
			moneyFormat = window.shop.moneyFormat;
			lineItem.find('.cart-item__line-price').html(Shopify.formatMoney(lineItemLinePrice, moneyFormat));
			$('.cart__total-amount').html(Shopify.formatMoney(data['total_price'], moneyFormat));
			

			// Trigger event so that other part of the code can update other code like the top cart
			var val = $(document).trigger('cart.updated', data);
		}
	});
	if (forceReload){
		reloadCart();
	}  
  if(quantity>0){
    execute = 1;
  }
  $('.btn-product_cart-close').delay(2000).focus();
}

$(document).on('cart.updated', reloadCart);


$(".scroll-arrow--top").click(function () {
        var TopPos = $('.product__slideshow--nav').scrollTop();
        $(".product__slideshow--nav").animate({scrollTop: TopPos - 170}, 300);
});

$(".scroll-arrow--bottom").click(function () {
        var BottomPos = $('.product__slideshow--nav').scrollTop();
        $(".product__slideshow--nav").animate({scrollTop: BottomPos + 170}, 300);
});

var quantitySlideshowNavImage = $(".product__slideshow-nav-image").length;
if (quantitySlideshowNavImage < 5){
  $(".scroll-arrow--top").css("display", "none");
  $(".scroll-arrow--bottom").css("display", "none");
}


function get_cart() {
        var result = {};
        $.ajax({
            url: '/cart.js',
            dataType: 'json',
            async: false
        }).always(function(response) {
            result = response;
        });
        return result;
}

function generateSideCartBlock(){
  		var items = get_cart().items
        var sideCartBlock = '';
		var totalPrice = 0;
  		var lineIndex = 0;
  		items.forEach(function(item){
    		var price = parseFloat(item.line_price/100).toFixed(2)
            totalPrice+=item.line_price;
            var varientTitle = item.variant_title.split("/");
            var varientTitle1 = varientTitle[0];
            var varientTitle2 = varientTitle[1];
            var block =
        '<div class="product_cart-item-wrapper cart__item">'+
        	'<div class="display-inline-block vertical-top">'+
        		'<img class="cart-item__image" src="'+item.image+'">'+
        	'</div>'+
        	'<div class="display-inline-block product_cart-item--description">'+
              '<a href="/collections/vendors?q=Room%20Service%20PJs" class="cart-item__vendor">'+item.vendor+'</a>'+
              '<a href="{item.url}" class="cart-item__title">'+item.product_title+'</a>'+
              '<p tabindex="0" aria-label="Fabric print is '+varientTitle1+'and Size is'+varientTitle2+'"  class="cart-item__variant">'+varientTitle1+'/'+varientTitle2+'</p>'+
        		'<ul class="cart-item__properties list--unstyled">'+
        		'</ul>'+
        		'<div class="cart-item__actions">'+
        			'<div class="quantity__wrapper quantity__wrapper-right">'+
                    '<script>'+
                        'var quantityMinus = $(".cart-item__quantity").val(); var quantityMinusOne = parseInt(quantityMinus) - 1; var quantityPlus = $(".cart-item__quantity").val(); var quantityPlusOne = parseInt(quantityPlus) + 1;'+
                    '</script>'+
                        '<span tabindex="0" aria-label="decrease quantity" onclick="decrementProductQuantity($(this))" class="quantity-arrow-minus"> − </span>'+
        				'<input onchange="updateProductQuantity($(this))" data-line-item-index="'+(++lineIndex) +'" class="product__quantity cart-item__quantity" pattern="[0-9]*" type="number" min="1" value="'+item.quantity+'">'+
        			    '<span tabindex="0" aria-label="Increase quantity" onclick="incrementProductQuantity($(this))" class="quantity-arrow-plus"> + </span>'+
                    '</div>'+
        			'<div class="cart-item__price-and-remove">'+
                      '<span tabindex="0" class="cart-item__line-price" data-money-convertible="">$ '+price+'</span>'+
						'<a tabindex="0" onclick="updateProductQuanitityInCart($(this).closest(\'.cart-item__actions\').find(\'.cart-item__quantity\'),0,true)" aria-label="remove item" class="cart-item__remove link--primary" style="cursor: pointer">Remove</a>'+
					'</div>'+
        		'</div>'+
        	'</div>'+
        '</div>';

        sideCartBlock+=block;
		})

        $('.cart__total-amount').text('$'+parseFloat(totalPrice/100).toFixed(2))


        var test = totalPrice/100;
  		if (test >= 150) {
          $('.quick-shop-free').first().bPopup({
            positionStyle: 'fixed',
            onOpen: function() {
              var quickShop = $(this),
                  isInitialized = quickShop.attr('data-initialized');

              // First, let's initialize the various resources (images, and slideshow)
              if (isInitialized === 'false') {
                var slider = quickShop.find('.quick-shop__slideshow').slick({
                  fade: true,
                  adaptiveHeight: true,
                  lazyLoad: 'progressive',
                  arrows: false,
                  dots: false
                }).slick('getSlick');

                // Finally, let's initialize the product selectors
                //  window['initializeQuickShop' + productId]();

                $(document).on('variant_changed.quick_shop', function(event, variant) {
                  if (variant['featured_image']) {
                    var position = quickShop.find('.quick-shop__slideshow-slide[data-image-id="' + variant['featured_image']['id'] + '"]').index();
                    slider.goTo(position);
                  }
                });

                quickShop.attr('data-initialized', 'true');
              }
            }
          });
        }
  		return sideCartBlock;
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

function scrollToReview() {
    $('html, body').animate({
        scrollTop: $('#review-stars-anchor').offset().top
    }, 800);
}





//// Definitions for cart page quantity update helpers ////

function updateProductQuantity(jqoInputQty, quantity, forceReload) {
  jqoCartItem = jqoInputQty.closest(".cart__item");
  if (quantity === 0) {
    //// Remove line item ////
    jqoButtonRemove = jqoCartItem.find(".cart-item__remove")[0].click();
  } else {
    updateProductQuanitityInCart(jqoInputQty, quantity, forceReload);
    //// Update line item subtotal ////
    jqoSpanUnitPrice = jqoCartItem.find(".cart-item__unit-price");
    jqoSpanItemSubtotal = jqoCartItem.find(".cart-item__line-price");
    jqoSpanItemSubtotal.text(
      Shopify.formatMoney(
        parseInt(jqoSpanUnitPrice.data("unit-price")) * quantity
      )
    );
  }
  cartQtyForCartIcon();
}

function decrementProductQuantity(jqoButtonMinus) { 
    jqoInputQty = jqoButtonMinus
    .closest(".cart-item__actions")
    .find(".cart-item__quantity");
    cartQtyForCartIcon();
    updateProductQuantity(jqoInputQty, parseInt(jqoInputQty.val()) - 1, true);
}

function incrementProductQuantity(jqoButtonPlus) {
    jqoInputQty = jqoButtonPlus
    .closest(".cart-item__actions")
    .find(".cart-item__quantity");
    cartQtyForCartIcon();
    updateProductQuantity(jqoInputQty, parseInt(jqoInputQty.val()) + 1, true);
}

//// Behavior for sticky desktop scrollbar ////

$(document).on('ready', function(){
  var jqoHeader = $('.header__wrapper')
  var stickyOffset = $('.main')[0].offsetTop;
  window.onscroll = function() {
    if (window.pageYOffset > stickyOffset) {
      if (!jqoHeader.hasClass('header__wrapper--sticky')) {
        jqoHeader.addClass('header__wrapper--sticky');
        $('.header__controls--right').append($('.mega-search__form')).append($('.mega-search__suggestions'));
        $('.header__controls--left').append($('#nav'));
        $('.main').addClass('padded-for-header')
      }
    } else {
      if (jqoHeader.hasClass('header__wrapper--sticky')) {
        jqoHeader.removeClass('header__wrapper--sticky')
        $('.header__container').append($('#nav'));
        $('.header__controls--left').append($('.mega-search__form')).append($('.mega-search__suggestions'));
        $('.main').removeClass('padded-for-header')
      }
    }
  };
});

//// Free Shipping Bar duplicate in side-cart ////

$(document).on('ready', function(){
  try{
    var observer = new MutationObserver(function(mutations) {
        $('.fsb_placeholder').empty().append($('#fsb_placeholder > div').clone(true))  
      });

      observer.observe($('#fsb_placeholder')[0], {
        childList: true
      })
  }catch(e){
    console.log(e);
  }
  
});

var autoaddtocart= function (cart, val){
  if(val==1){
    let productJson = JSON.parse(AutoProductJson.innerHTML);
  let autosettings = parseInt(JSON.parse(AutoProductSettingJson.innerHTML));
  if(Number.isNaN(autosettings)){
    autosettings = 1;
    return;
  }
  if(productJson!=''){
    let productoncart=false;
    if((cart.total_price/100)>autosettings){
      $.each( cart.items, function( cartkey, cartvalue ) {
        $.each( productJson, function( productkey, productvalue ) {
          if(cartvalue.variant_id==productvalue.id){
            productoncart = true;
            return;
          }
        });                 
      }); 
      if(!productoncart){          
        let verintid = getverintId(productJson);           
        if(verintid !=''){           
            CartJS.addItem(verintid,1);
            $.ajax({
              url: '/cart.js',
              dataType: 'json'
            }).always(function(cart) {
              $(document).trigger('cart.updated', cart);
            });                       
        }         
      }        
    }

  } 
  
  execute = 0;
   
  }   
}

function getverintId(productjs){
  let final='';
  $.each( productjs, function( key, value ) {
    if(value.available){
      final= value.id;        
      return false;    
    }
  });

  return final;
}

let execute = 0;

$(document).ready(function() { 
  if ($(window).width() < 768) {
    // alert('Less than 768');
    $('.button--quick-shop').remove();
    $('.quick-shop').remove();
 }

});

$(document).ready(function () {
  $('.product__option-selector').focus(function () {


  });
});

$(document).ready(function () {
  $('.product-item__figure > a').focus(function () {
    $(this).find('.button--quick-shop').css({ "display": "block" });

  });
});

$(document).ready(function () {
  $('.product-item__details > a').focus(function () {
    $(this).parent('.product-item__details').siblings('.product-item__figure').find('.button--quick-shop').css({ "display": "none" });

  });
});

$( document ).ready(function() {
  
    $('#slick-slide00').find('button').attr('aria-label', 'Slider banner 1');
    $('#slick-slide01').find('button').attr('aria-label', 'Slider banner 2');
    $('#slick-slide02').find('button').attr('aria-label', 'Slider banner 3');
    
});

$(document).on('cart.requestComplete', function(event, cart) { 
  var result = {};
  $.ajax({
      url: '/cart.js',
      dataType: 'json',
      async: false
  }).always(function(response) {
      result = response;
  });
  return result;
});


// for displaying selected size in pdp -  when on load
$(window).on('load' , function() {  
  // $('.product__slideshow-image--zoomed').attr('aria-hidden','true');
  // $('.aspect-ratio').find('.zoomImg').attr('aria-hidden','true');
  $('.aspect-ratio').siblings().attr('aria-hidden','false');
  $('.aspect-ratio').siblings().attr('tabindex', -1);
  $('.aspect-ratio').siblings().first().attr('tabindex',0);
  $('.aspect-ratio').siblings().first().attr('aria-hidden','true');
  $('.product__slideshow-slide.slick-slide.slick-current.slick-active').attr('tabindex', -1);


  $(".index-module__title cart-page__title").focus();
  $('.slick-active').attr('tabindex',  0 );
  // oops Incorrect email or password. on login page
  $('#oopsLogin').focus();

  var sectionid = $('.ClsforselectedValueForLbl').attr("data-text");
  if(sectionid == 'product' || sectionid == 'product_gift_card'){
  var selectedText = $('.ClsforselectedValueForLbl').find("option:selected").text();
  $("#selectedSizeOption").text('Selected size is '+ selectedText);
  $('.afterpay-link').attr('aria-label', 'Afterpay  Information ');

  // $('.product__variants').find('.selector-wrapper').css('display','none');
  // console.log();
  $('#sizeDropdown button:last').addClass('lastDropdownItem');
  $('#sizeDropdown button:first-child').addClass('firstDropdownItem');
  $('#sizeDropdown button:nth-child(2)').addClass('secondDropdownItem');

  
  }

  // change input field aria label on load
  // var inputValueForPdp =  $('.quantity__wrapper').find('.product__quantity').val();
  // $('.quantity__wrapper').find('.product__quantity').siblings('.quantity-arrow-minus').attr('aria-label', 'Quantity decrement button, and selected Quantity is '+ inputValueForPdp );
  // $('.quantity__wrapper').find('.product__quantity').siblings('.quantity-arrow-plus').attr('aria-label', 'Quantity increment button, and selected Quantity is '+ inputValueForPdp );
  // product__slideshow-slide slick-slide slick-current slick-active

});

// oops Incorrect email or password. on login page
$(document).ready(function () {

  $('#subButton').focus(function () {
    $('#subButton').css("border", "2px solid blue");

  }).blur(function(){
    $('#subButton').css("border", "2px solid red");
  });
});



// $('.quantity__wrapper').find('.product__quantity').bind('keyup change click', function (e) {
//   let value = $(this).val();  
//   $(this).siblings('.quantity-arrow-minus').attr('aria-label', 'Quantity decrement button, and selected Quantity is '+ value );
//   $(this).siblings('.quantity-arrow-plus').attr('aria-label', 'Quantity increment button, and selected Quantity is '+ value );
// });




// ------------------------------------------------------------------------------
// ADA dropdown
/* When the user clicks on the button, 
toggle between hiding and showing the dropdown content */

function sizeDropdownOpenClose() {
  document.getElementById("sizeDropdown").classList.toggle("show");
  var foptionVal = $('.firstDropdownItem').text();
  
  $('.firstDropdownItem').attr('aria-label','dropdown opened, size '+foptionVal);
  $('.firstDropdownItem').focus();
  
}

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  // Check if the click is on the button or inside an <svg> inside the button
  if (!event.target.matches('.dropbtn') && !event.target.closest('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    for (var i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
};


// ----------- new dropdown function for ADA  ----------

  // new dropdown get values and set button to selected text 
$(".dropdownItem").click(function () {
  let selectedText = $(this).text();
  let selectedValue = $(this).data('varient-id');

  // if(selectedText != undefined){
    $("#sizeDropbtn").text(selectedText);
     // get hidden select option values
     $(".ClsforselectedValueForLbl").find("option").each(function () {
      let hidden_option = $(this).text().trim();
      let hidden_selectedValue = $(this).val();
      if (hidden_selectedValue == selectedValue) {
        $('#sizeDropbtn').attr('aria-label','selected size is '+selectedText);
        let numericValue = parseFloat(selectedText.replace(/[^0-9.-]+/g, ""));
        if (!isNaN(numericValue)) {
            let formattedValue = numericValue.toLocaleString("en-US", { 
                style: "currency", 
                currency: "USD" 
            }); // Format as USD currency
            $('.product__price').text(formattedValue);
        }
        
        // change selected option 
        setTimeout(() => {
          $('.ClsforselectedValueForLbl').val(selectedValue).trigger('change');
          $('.single-option-selector').val(hidden_option);
          // console.log(hidden_option);
          $(".gift-page-drop-down").append(`
              <span style="float: right;">
                  <svg class="icon icon-arrow-bottom" width="16px" height="9px" viewBox="0 0 10 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path fill="none" stroke="#000" stroke-linecap="round" d="M9 0L5 4 1 0"></path>
                  </svg>
              </span>
          `);
          
          $('#sizeDropbtn').focus();
         }, 400);
      }
    });
  // }
    
  });

  // qty changing and focusing qty input function 
  $('.quantity__wrapper').find('.quantity-arrow-plus').on('keypress', function(){
    var currentQty = $('.quantity__wrapper').find('#quantity-').val();
    currentQty++;
    $('.quantity__wrapper').find('#quantity-').attr('aria-label', 'quantity increased, quantity is '+ currentQty++);
    $('.quantity__wrapper').find('#quantity-').focus();
  });

  $('.quantity__wrapper').find('.quantity-arrow-minus').on('keypress', function(){
    var currentQty = $('.quantity__wrapper').find('#quantity-').val();
    currentQty--;
    $('.quantity__wrapper').find('#quantity-').attr('aria-label', 'quantity decreased , quantity is '+ currentQty--);
    $('.quantity__wrapper').find('#quantity-').focus();
  });

$('.loox-on-pdp-top').on('click', function(e) {
  e.preventDefault(); // prevent default behavior if it's a link

  $('html, body').animate({
    scrollTop: $('#looxReviews').offset().top
  }, 800); // 800 = scroll duration in ms
});


//for reviews 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.loox-rating').forEach((rating, index) => {
    const value = rating.getAttribute('data-rating');
    const raters = rating.getAttribute('data-raters');

    // Make focusable
    rating.setAttribute('tabindex', '0');

    // Correct semantic role
    rating.setAttribute('role', 'img');

    // Accessible text
    const labelId = `loox-rating-label-${index}`;
    let srText = `Rated ${value} out of 5 stars based on ${raters} review${raters === '1' ? '' : 's'}`;

    // Create hidden SR text
    let srSpan = document.createElement('span');
    srSpan.id = labelId;
    srSpan.textContent = srText;
    srSpan.style.position = 'absolute';
    srSpan.style.left = '-9999px';

    rating.appendChild(srSpan);

    rating.setAttribute('aria-describedby', labelId);
  });
});

function hideZoomImagesFromScreenReaders() {
    document.querySelectorAll('.zoomImg').forEach(img => {
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('alt', '');
      img.setAttribute('tabindex', '-1');
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', hideZoomImagesFromScreenReaders);

  // Watch for dynamically added zoom images
  const observer = new MutationObserver(hideZoomImagesFromScreenReaders);
  observer.observe(document.body, { childList: true, subtree: true });